__turbopack_context__.v({
  "card": "fc7tvW_card",
});
